import React from "react";

export interface ModalBodyProps {
  className?: string;
  children: React.ReactNode;
}

const ModalBody: React.FC<ModalBodyProps> = ({ className = "", children }) => {
  return <div className={`p-6 ${className}`}>{children}</div>;
};

export default ModalBody;
